import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import type { User } from '../../../models/user.model';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private http = inject(HttpClient);

    private currentUserSubject: BehaviorSubject<User>;
    currentUser: Observable<User>;

    constructor() {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
    get isUserLoggedIn(): boolean {
        return this.currentUserSubject.value ? this.currentUserSubject.value.type === 'member': false;
    }

    get isAdminLoggedIn(): boolean{
        
        return this.currentUserSubject.value ? this.currentUserSubject.value.type === 'admin': false;
    }
  
    login(username: string, password: string, users: User[]) {
        return this.http.post<User>(`/users/authenticate`, { username, password, users })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}